module.exports = __webpack_public_path__ + "img/pinterest.33e65478.svg";